import { Dayjs, dayjs } from 'date';

import { DEFAULT_DAYS } from './constants';

export const formatFilterDate = (date: Dayjs) => date.toISOString();
export const createFromFilter = (date: Dayjs, fieldName: string) => ({
  field: fieldName,
  operator: 'gte',
  value: formatFilterDate(date),
});
export const createToFilter = (date: Dayjs, fieldName: string) => ({
  field: fieldName,
  operator: 'lte',
  value: formatFilterDate(date),
});

export const initialFromFilter = (fieldName: string) => createFromFilter(dayjs(), fieldName);

export const initialToFilter = (fieldName: string) => createToFilter(DEFAULT_DAYS, fieldName);
